import {
  Dialog,
  DialogContent,
  Typography,
} from '@mui/material';
import './NotificationBlocker.scss';
import { filterUndefined } from '../../utils/FilterUndefinedObject';

/**
 * A component for blocking user interaction on the screen
 */
const defaultProps = {
  show: false,
  Icon: null,
  loaderIcon: null,
};

export default function NotificationBlocker(props) {
  const { show, Icon, loaderIcon, message, ...rest } = { ...defaultProps, ...filterUndefined(props) };
  return show ? (
    <Dialog open={show} className='notification-blocker' transitionDuration={1000} {...rest}>
      <DialogContent className='notification-blocker-content'>
        {Icon ? (
          <div className='notification-blocker-icon-container'>
            <Icon className='notification-blocker-icon' />
          </div>
        ) : ''}

        {loaderIcon ? (
          <div className='notification-blocker-icon-container'>
            {loaderIcon}
          </div>
        ) : ''}

        <Typography variant='h6' data-dd-privacy='mask'>
          {message}
        </Typography>
      </DialogContent>
    </Dialog>
  ) : '';
}
